import FormWrapper from '@components/search/forms/FormWrapper'
import AgriForm from '@components/search/forms/AgriForm'
import { frontpageLinks } from '@components/search/formLinks'

const AgriSearchpageForm = ({ query }) => {
    return (
        <FormWrapper
            Form={AgriForm}
            formLinks={frontpageLinks}
            overrideDefaultValues={query}
            active={4}
            linksOnTop
        />
    )
}

export default AgriSearchpageForm